import React from "react";
import feature1 from "../../../assets/img/feature1.png";
import feature2 from "../../../assets/img/feature2.png";
import feature3 from "../../../assets/img/feature3.png";
import feature4 from "../../../assets/img/feature4.png";
import feature5 from "../../../assets/img/feature5.png";
import feature6 from "../../../assets/img/feature6.png";
import logo from "../../../assets/img/logo.png";

const features = [
	{
		title: "Pengajaran",
		description:
			"Lorem ipsum dolor sit amet consectetur. Justo iaculis porttitor nunc duis gravida cursus elementum. Sit eu diam dignissim sit suspendisse ut. Bibendum vehicula sed risus morbi lacinia. In malesuada pretium velit dignissim tincidunt vulputate purus donec.",
		image: feature1,
	},
	{
		title: "Secure Mode",
		description:
			"Lorem ipsum dolor sit amet consectetur. Justo iaculis porttitor nunc duis gravida cursus elementum. Sit eu diam dignissim sit suspendisse ut. Bibendum vehicula sed risus morbi lacinia. In malesuada pretium velit dignissim tincidunt vulputate purus donec.",
		image: feature2,
	},
	{
		title: "Monitoring",
		description:
			"Lorem ipsum dolor sit amet consectetur. Justo iaculis porttitor nunc duis gravida cursus elementum. Sit eu diam dignissim sit suspendisse ut. Bibendum vehicula sed risus morbi lacinia. In malesuada pretium velit dignissim tincidunt vulputate purus donec.",
		image: feature3,
	},
	{
		title: "School Drive",
		description:
			"Lorem ipsum dolor sit amet consectetur. Justo iaculis porttitor nunc duis gravida cursus elementum. Sit eu diam dignissim sit suspendisse ut. Bibendum vehicula sed risus morbi lacinia. In malesuada pretium velit dignissim tincidunt vulputate purus donec.",
		image: feature4,
	},
	{
		title: "Evaluasi",
		description:
			"Lorem ipsum dolor sit amet consectetur. Justo iaculis porttitor nunc duis gravida cursus elementum. Sit eu diam dignissim sit suspendisse ut. Bibendum vehicula sed risus morbi lacinia. In malesuada pretium velit dignissim tincidunt vulputate purus donec.",
		image: feature5,
	},
	{
		title: "Catatan Guru",
		description:
			"Lorem ipsum dolor sit amet consectetur. Justo iaculis porttitor nunc duis gravida cursus elementum. Sit eu diam dignissim sit suspendisse ut. Bibendum vehicula sed risus morbi lacinia. In malesuada pretium velit dignissim tincidunt vulputate purus donec.",
		image: feature6,
	},
];

function ListFeature() {
	return (
		<div className="feature">
			<div className="header">
				<div
					className="flex justify-center items-center"
					style={{ flexDirection: "column" }}
				>
					<h1 className="border-b-2 border-yellow-500 font-bold hover:cursor-pointer hover:text-[#EF9105] mb-2 text-xl">
						Feature
					</h1>
					<span className="text-center mt-3">
						Berbagai macam fitur dari aplikasi Geschool yang memungkinkan
						membantu digitalisasi proses pembelajaran.
					</span>
				</div>
			</div>
			<div className="content">
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 p-5">
					{features.map((feature, index) => (
						<div
							key={index}
							className="flex flex-row items-center justify-between gap-4 rounded-lg bg-white p-5 shadow-md md:flex-row md:text-left"
						>
							<div className="flex-1 text-left">
								<img src={logo} alt="Logo" className="mb-2.5 h-10 w-10" />
								<h3>
									<strong>{feature.title}</strong>
								</h3>
								<p className="text-justify">{feature.description}</p>
							</div>
							<img
								src={feature.image}
								alt={feature.title}
								className="ml-5 h-auto max-w-[100px] md:ml-5 md:mb-0 md:max-w-[100px]"
							/>
						</div>
					))}
					<div className="col-span-1 text-center mt-5 md:col-span-2 lg:col-span-3">
						<button className="cursor-pointer rounded-lg border-none bg-amber-500 px-5 py-2.5 text-white hover:bg-amber-600">
							Lihat Fitur Lainnya
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default ListFeature;
